export class AemInitialize {
  static readonly type = '[AEM] initialize';

  constructor(public model: any) {
  }
}

export class AemGet {
  static readonly type = '[AEM] get';

  constructor(public path: string) {
  }
}

export class AemGetMessages {
  static readonly type = '[AEM] getMessages';

  constructor(public path: string) {
  }
}

export class AemGetAppConfig {
  static readonly type = '[AEM] getAppConfig';

  constructor(public path: string) {
  }
}

export class AemGetMaintenance {
  static readonly type = '[AEM] getAemGetMaintenance';

  constructor(public path: string) {
  }
}
